var eduutils = eduutils || {};

module.exports = eduutils;

eduutils.StartWithDocActions = "false";
eduutils.toggleMenuBreakPoint = 769;

eduutils.ToggleCourseMenu = function () {
  //Opens
  if (!$(".menu").hasClass("selected")) {
    $("#OpenCourseMaterial").removeClass("active");
    $(".lastVisitedFrame").removeClass("hidden");
    if (matchMedia) {
      $(
        ".doc-actions, .content-edu, .header-wrapper, .course-switcher",
      ).addClass("pushed");
      $(".doc-actions, .content-edu, .header-wrapper").removeClass("moveleft");
    }
    $(".toolbar-bottom").removeClass("hidden");
    eduutils.SetCourseMenuState();
  }
  //Closes
  else {
    eduutils.CloseCourseSubMenus();
    $(".lastVisitedFrame").addClass("hidden");
    $(
      ".doc-actions, .content-edu, .header-wrapper, .course-switcher",
    ).removeClass("pushed");
    if (window.matchMedia("( max-width:1600px)").matches) {
      $(".doc-actions, .content-edu, .header-wrapper").addClass("moveleft");
      $(
        ".doc-actions, .content-edu, .header-wrapper, .course-switcher",
      ).removeClass("pushed");
    }
    $(".menu-column").scrollTop(0);

    //Remove scroll lock
    $("body").removeClass("fixed");

    $("#OpenCourseMaterial").addClass("active");
    $(".toolbar-bottom").addClass("hidden");
  }

  $(".menu").toggleClass("selected");
  $(".course.menu").trigger("stateChanged");
};

eduutils.SetCourseMenuState = function () {
  try {
    if (luvit.getItem("luvit_coursemenustate")) {
      var activeMenu = $.parseJSON(
        luvit.getItem("luvit_coursemenustate"),
      ).active;

      //set overview as active when first logging in
      if (!activeMenu && activeMenu != "") activeMenu = 27;
    } else {
      if (!activeMenu) activeMenu = 27;
    }

    //only activate item in menu if nothing is active in navtree
    if (!luvitedu.getActiveNavtreeId()) {
      const container = $(".menu-coursemenu");

      let item = container.find("li[data-id='" + activeMenu + "']");
      if (item.length == 0)
        item = container.find("li[data-id='" + activeMenu + "']");

      $(item).closest("ul.menu-expandlist-content").removeClass("contracted");

      //Toggle expand/collapse icons
      let iconToggle = $(item).parent().closest("li").find(".icon-expand");
      if (iconToggle[0]) {
        $(iconToggle).removeClass();
        $(iconToggle).addClass("icon-collapse");
      }

      container
        .find(".menu-column .menu-functionmenu li.active")
        .removeClass("active");
      $(item).addClass("active");
    }
  } catch (err) {
    //do nothing
  }
};

eduutils.DeselectCourseMenu = function () {
  eduutils.SetCourseMenuState("");
  if ($(".course.menu").length > 0) {
    $(".course.menu .menu-functionmenu li").removeClass("active");
  } else {
    parent.$(".course.menu .menu-functionmenu li").removeClass("active");
  }
};

eduutils.CloseCourseSubMenus = function () {
  $(".course.menu .menu-functionmenu .menu-expandlist-content").addClass(
    "contracted",
  );

  $(".course.menu .menu-functionmenu")
    .not("#mycourseslist")
    .find(".icon-collapse")
    .addClass("icon-expand")
    .removeClass("icon-collapse");
};

eduutils.SetActiveCourseMenuItem = function (menuItemId) {
  let state = { active: menuItemId };

  if (luvit.getItem("luvit_coursemenustate")) {
    let menuState = JSON.parse(luvit.getItem("luvit_coursemenustate"));
    menuState.active = menuItemId;
    luvit.setItem(
      "luvit_coursemenustate",
      '{ "main": "' +
        menuState.main +
        '", "active":"' +
        menuState.active +
        '"}',
    );
  } else {
    luvit.setItem("luvit_coursemenustate", '{"active":"' + state.active + '"}');
  }
};
